/**
 * Helper function to get the public asset URL
 * @param path - The path of the asset
 * @returns The public asset URL
 */
export const getPublicAssetUrl = (path: string): string => {
  if (!path) {
    return '';
  }
  if (process.env.ASSET_PREFIX) {
    return `${process.env.ASSET_PREFIX}${path}`;
  }
  return path;
};
